import React from "react";
import { Link } from "react-router-dom";
import { useInView } from "react-intersection-observer";
import { keyframes } from "@emotion/react";

// @mui material
import Container from "@mui/material/Container";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';

// icons
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";

// images
import Ecommerce from "../static/images/projects/Ecommerce.jpeg";
import Activities from "../static/images/projects/Activities.jpeg";
import autoexp from "../static/images/projects/autoexp.png";
import utec from "../static/images/projects/utec.png";
import Rental from "../static/images/projects/Rental.jpeg";
import TeamManagment from "../static/images/projects/teamMana.png";
// Define the animation keyframes
const fadeIn = keyframes`
  from { opacity: 0; transform: translateY(20px); }
  to { opacity: 1; transform: translateY(0); }
`;

const animatedStyles = (inView) => ({
  animation: inView ? `${fadeIn} 1s ease-in-out` : "none",
  opacity: inView ? 1 : 0,
  transition: "opacity 0.5s ease-in-out, transform 0.5s ease-in-out",
});

export default function Projects() {
  const { ref: projectsHeaderRef, inView: projectsHeaderInView } = useInView({
    triggerOnce: false,
    threshold: 0.1,
  });
  const { ref: ecommerceRef, inView: ecommerceInView } = useInView({
    triggerOnce: false,
    threshold: 0.1,
  });
  const { ref: rentalRef, inView: rentalInView } = useInView({
    triggerOnce: false,
    threshold: 0.1,
  });
  const { ref: autoexpRef, inView: autoexpInView } = useInView({
    triggerOnce: false,
    threshold: 0.1,
  });
  const { ref: utecRef, inView: utecInView } = useInView({
    triggerOnce: false,
    threshold: 0.1,
  });
  const { ref: activitiesRef, inView: activitiesInView } = useInView({
    triggerOnce: false,
    threshold: 0.1,
  });

  return (
    <>
      <style>{`
        .svg-icon {
          height: 40px;
          width: 40px;
          fill: #007bff;
          transition: fill 0.3s ease-in-out;
        }
        .section-header:hover .svg-icon {
          // fill: #28a745;
        }
      `}</style>

      <div className="experience-section project-section">
        <Container maxWidth="lg">
          <Box className="section-header" ref={projectsHeaderRef} sx={animatedStyles(projectsHeaderInView)}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="svg-icon"
            >
              <rect x="2" y="3" width="20" height="14" rx="2" ry="2" />
              <line x1="8" y1="21" x2="16" y2="21" />
              <line x1="12" y1="17" x2="12" y2="21" />
            </svg>
            <h4 className="section-title">Projects</h4>
          </Box>


          <Grid container spacing={3} marginBottom={1}>
            {/* Ecommerce Project */}

            <Grid
              item
              // size={6}
              xs={12}
              md={6}
              ref={ecommerceRef}
              sx={animatedStyles(ecommerceInView)}
            >
              <Link to="https://store.elhamalassta.com" className="btn-icon btn">
                <div className="card">
                  <div className="card-body">
                    <img
                      width="100%"
                      src={Ecommerce}
                      alt="Ecommerce"
                      height="200px"
                      style={{ objectFit: "cover" }}
                    />
                    <div className="card-description">
                      <div className="pl-4 flex-grow-1">
                        <h3 className="item-title">Ecommerce</h3>
                        <Typography className="item-description">
                          A multilingual web store with a shopping cart and various payment options. The project includes a control panel to manage content, orders, and a billing system, implemented with Laravel, Flutter, and ReactJs.
                        </Typography>
                        <Button variant="contained">

                          <ArrowForwardIcon /> Demo

                        </Button>
                      </div>
                    </div>
                  </div>
                </div>
              </Link>
            </Grid>
            {/* A React-powered Website with Laravel Backend */}
            <Grid
              item
              // size={6}
              xs={12}
              md={6}
              ref={rentalRef}
              sx={animatedStyles(rentalInView)}
            >
              <Link to="https://rent.elhamalassta.com" className="btn-icon btn">
                <div className="card">
                  <div className="card-body">
                    <img
                      width="100%"
                      src={Rental}
                      alt="Miran Cars"
                      height="200px"
                      style={{ objectFit: "cover" }}
                    />
                    <div className="card-description">
                      <div className="pl-4 flex-grow-1">
                        <h3 className="item-title">
                          Real Estate Rental
                        </h3>
                        <Typography className="item-description">

                          This project is a comprehensive Real Estate Rental Website that serves as a platform for property owners to list their properties and for users to find and rent them.

                          Developed with a powerful combination of React.js for a dynamic front-end and Laravel for a secure back-end, the application provides a seamless and intuitive user experience.
                        </Typography>
                        <Button variant="contained">

                          <ArrowForwardIcon /> Demo

                        </Button>
                      </div>
                    </div>
                  </div>
                </div>
              </Link>
            </Grid>

            {/* Autoexp */}
            <Grid
              item
              // size={6}
              xs={12}
              md={6}
              ref={autoexpRef}
              sx={animatedStyles(autoexpInView)}
            >
              <a
                href="https://autoexp.ae/"
                target="_blank"
                rel="noopener noreferrer"
                className="btn-icon btn"
                aria-label="autoexp.ae"
              >
                <div className="card">
                  <div className="card-body">
                    <img
                      width="100%"
                      src={autoexp}
                      alt="autoexp"
                      height="200px"
                      style={{ objectFit: "cover" }}
                    />
                    <div className="card-description">
                      <div className="pl-4 flex-grow-1">
                        <h3 className="item-title">Autoexp</h3>
                        <Typography className="item-description">
                          This project is a website for car dent repairs in Dubai, offering a clean, professional user experience for clients to find and book services.
                        </Typography>
                        <Button variant="contained">
                          <ArrowForwardIcon /> Demo
                        </Button>
                      </div>
                    </div>
                  </div>
                </div>
              </a>
            </Grid>

            {/* Utec */}
            <Grid
              item
              // size={6}
              xs={12}
              md={6}
              ref={utecRef}
              sx={animatedStyles(utecInView)}
            >
              <a
                href="https://www.utec.com.sa/"
                target="_blank"
                rel="noopener noreferrer"
                className="btn-icon btn"
                aria-label="utec"
              >
                <div className="card">
                  <div className="card-body">
                    <img
                      width="100%"
                      src={utec}
                      alt="Utec"
                      height="200px"
                      style={{ objectFit: "cover" }}
                    />
                    <div className="card-description">
                      <div className="pl-4 flex-grow-1">
                        <h3 className="item-title">Utec</h3>
                        <Typography className="item-description">
                          UTEC Quality solutions serve various segments of the Saudi Market, including Utility, mega construction, Oil & Gas, and Transportation. This website showcases their comprehensive range of services and solutions.
                        </Typography>
                        <Button variant="contained">
                          <ArrowForwardIcon /> Demo
                        </Button>
                      </div>
                    </div>
                  </div>
                </div>
              </a>
            </Grid>

            {/* Activities Website */}
            <Grid
              item
              // size={6}
              xs={12}
              md={6}
              ref={activitiesRef}
              sx={animatedStyles(activitiesInView)}
            >
              <Link to="https://activites.elhamalassta.com" className="btn-icon btn">
                <div className="card">
                  <div className="card-body">
                    <img
                      width="100%"
                      src={Activities}
                      alt="Activities"
                      height="200px"
                      style={{ objectFit: "cover" }}
                    />
                    <div className="card-description">
                      <div className="pl-4 flex-grow-1">
                        <h3 className="item-title">Activities Website</h3>
                        <Typography className="item-description">
                          This website facilitates activities and events, allowing for the sending of invitations and the reservation of seats based on the social status of the invitee. It streamlines the event management process with a user-friendly interface.
                        </Typography>
                        <Button variant="contained">
                          <ArrowForwardIcon /> Demo
                        </Button>
                      </div>
                    </div>
                  </div>
                </div>
              </Link>
            </Grid>

            {/* Team Managment Website */}
            <Grid
              item
              // size={6}
              xs={12}
              md={6}
              ref={activitiesRef}
              sx={animatedStyles(activitiesInView)}
            >
              <Link to="https://teammng.elhamalassta.com" className="btn-icon btn">
                <div className="card">
                  <div className="card-body">
                    <img
                      width="100%"
                      src={TeamManagment}
                      alt="TeamManagment"
                      height="200px"
                      style={{ objectFit: "cover" }}
                    />
                    <div className="card-description">
                      <div className="pl-4 flex-grow-1">
                        <h3 className="item-title">Team Managment Website</h3>
                        <Typography className="item-description">
                          This project is a comprehensive Team Management Website designed to streamline and automate project and task management within a company. The application is built using a modern technology stack, with React.js powering the dynamic front-end and Laravel handling the robust back-end and API.
                        </Typography>
                        <Button variant="contained">
                          <ArrowForwardIcon /> Demo
                        </Button>
                      </div>
                    </div>
                  </div>
                </div>
              </Link>
            </Grid>
          </Grid>
        </Container>
      </div>
    </>
  );
}